// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"12":"cards","332":"Post","443":"about"}[chunkId] || chunkId) + "." + {"12":"f599295f","332":"81d26345","443":"517cd5d3","679":"c65969af","727":"3c65f77c"}[chunkId] + ".js";
};